import { generatePath } from "react-router-dom";
import { DocumentManagerType } from "../api/APIClient";

const routePrefix = "/app";
const administrationPath = `${routePrefix}/administration`;
const projectPath = `${routePrefix}/project/:projectId`;
const toolsPath = `${projectPath}/tools`;
const documentationPath = `${toolsPath}/documentation`;
const maintenancePath = `${toolsPath}/maintenance`;
const settingsPath = `${projectPath}/settings`;
const signalsPath = `${projectPath}/signals`;

export const BDTRoutes = {
    Prefix: routePrefix,
    Home: routePrefix,
    Administration: {
        Administration: administrationPath,
        ForgeAccounts: `${administrationPath}/forgeAccounts`,
        Models: `${administrationPath}/models`,
        Projects: `${administrationPath}/projects`,
        Users: `${administrationPath}/users`,
        UsersGroups: `${administrationPath}/usersGroups`,
        PowerBIAccounts: `${administrationPath}/powerBIAccounts`,
    },
    Project: {
        Project: {
            Path: projectPath,
            Builder: (projectId: string): string =>
                generatePath(`${routePrefix}/project/:projectId`, { projectId }),
        },

        DashboardPowerBI: {
            Path: `${projectPath}/dashboardpowerbi`,
            Builder: (projectId: string): string =>
                generatePath(`${routePrefix}/project/:projectId/dashboardpowerbi`, { projectId }),
        },
        DashboardPowerApps: {
            Path: `${projectPath}/dashboardpowerapps`,
            Builder: (projectId: string): string =>
                generatePath(`${routePrefix}/project/:projectId/dashboardpowerapps`, { projectId }),
        },
        Dashboard: {
            Path: `${projectPath}/dashboard`,
            Builder: (projectId: string): string =>
                generatePath(`${routePrefix}/project/:projectId/dashboard`, { projectId }),
        },
        Viewer: {
            Viewer: {
                Path: `${projectPath}/viewer/:modelId?`,
                Builder: (projectId: string, modelId?: string): string =>
                    generatePath(`${routePrefix}/project/:projectId/viewer/:modelId?`, {
                        projectId,
                        modelId,
                    }),
            },
            Assets: {
                Path: `${projectPath}/viewer/:modelId/assets`,
                Builder: (projectId: string, modelId: string): string =>
                    generatePath(`${routePrefix}/project/:projectId/viewer/:modelId/assets`, {
                        projectId,
                        modelId,
                    }),
            },
            WorkOrders: {
                Path: `${projectPath}/viewer/:modelId/workOrders`,
                Builder: (projectId: string, modelId?: string): string =>
                    generatePath(`${routePrefix}/project/:projectId/viewer/:modelId?/workOrders`, {
                        projectId,
                        modelId,
                    }),
            },
            Documentation: {
                Path: `${projectPath}/viewer/:modelId/documentation`,
                Builder: (projectId: string, modelId: string): string =>
                    generatePath(
                        `${routePrefix}/project/:projectId/viewer/:modelId/documentation`,
                        {
                            projectId,
                            modelId,
                        }
                    ),
            },
            PowerBI: {
                Path: `${projectPath}/viewer/:modelId/powerbi`,
                Builder: (projectId: string, modelId?: string): string =>
                    generatePath(`${routePrefix}/project/:projectId/viewer/:modelId?/powerbi`, {
                        projectId,
                        modelId,
                    }),
            },
        },
        Tools: {
            Tools: {
                Path: toolsPath,
                Builder: (projectId: string): string => generatePath(`${toolsPath}`, { projectId }),
            },
            Documentation: {
                Path: documentationPath,
                Builder: (projectId: string): string =>
                    generatePath(documentationPath, { projectId }),
                Connectors: {
                    Path: `${documentationPath}/connectors`,
                    Builder: (projectId: string): string =>
                        generatePath(`${documentationPath}/connectors`, { projectId }),
                },
                Import: {
                    Path: `${documentationPath}/import`,
                    Builder: (projectId: string): string =>
                        generatePath(`${documentationPath}/import`, { projectId }),
                },
                Management: {
                    Path: `${documentationPath}/management`,
                    Builder: (projectId: string): string =>
                        generatePath(`${documentationPath}/management`, { projectId }),
                },
            },
            Maintenance: {
                Path: maintenancePath,
                Builder: (projectId: string): string =>
                    generatePath(maintenancePath, { projectId }),
                Connectors: {
                    Path: `${maintenancePath}/connectors`,
                    Builder: (projectId: string): string =>
                        generatePath(`${maintenancePath}/connectors`, { projectId }),
                },
            },
        },
        Settings: {
            Path: settingsPath,
            Builder: (projectId: string): string => generatePath(`${settingsPath}`, { projectId }),
            error: {
                Path: `${settingsPath}/error`,
                Builder: (projectId: string): string =>
                    generatePath(`${settingsPath}/error`, { projectId }),
            },
            PowerBI: {
                Path: `${settingsPath}/powerbi`,
                Builder: (projectId: string): string =>
                    generatePath(`${settingsPath}/powerbi`, { projectId }),
                Management: {
                    Path: `${settingsPath}/powerbi/management`,
                    Builder: (projectId: string): string =>
                        generatePath(`${settingsPath}/powerbi/management`, { projectId }),
                },
                AssetsManagement: {
                    Path: `${settingsPath}/powerbi/assetsmanagement`,
                    Builder: (projectId: string): string =>
                        generatePath(`${settingsPath}/powerbi/assetsmanagement`, { projectId }),
                },
            },
            Documents: {
                Path: `${settingsPath}/documentation`,
                Builder: (projectId: string): string =>
                    generatePath(`${settingsPath}/documentation`, {
                        projectId,
                    }),
                Management: {
                    Path: `${settingsPath}/documentation/management`,
                    Builder: (projectId: string): string =>
                        generatePath(`${settingsPath}/documentation/management`, { projectId }),
                },
                AssetsManagement: {
                    Path: `${settingsPath}/documentation/documentationassetsmanagement`,
                    Builder: (projectId: string): string =>
                        generatePath(
                            `${settingsPath}/documentation/documentationassetsmanagement`,
                            { projectId }
                        ),
                },
            },
            PowerApps: {
                Path: `${settingsPath}/powerapps`,
                Builder: (projectId: string): string =>
                    generatePath(`${settingsPath}/powerapps`, { projectId }),
            },
            AssetControl: {
                Path: `${settingsPath}/assetcontrol`,
                Builder: (projectId: string): string =>
                    generatePath(`${settingsPath}/assetcontrol`, { projectId }),
                Management: {
                    Path: `${settingsPath}/assetcontrol/management`,
                    Builder: (projectId: string): string =>
                        generatePath(`${settingsPath}/assetcontrol/management`, { projectId }),
                },
                Views: {
                    Path: `${settingsPath}/assetcontrol/views`,
                    Builder: (projectId: string): string =>
                        generatePath(`${settingsPath}/assetcontrol/views`, { projectId }),
                },
            },
            ViewControl: {
                Path: `${settingsPath}/viewsControl`,
                Builder: (projectId: string): string =>
                    generatePath(`${settingsPath}/viewsControl`, { projectId }),
            },
            Subscriptions: {
                Path: `${settingsPath}/subscriptions`,
                Builder: (projectId: string): string =>
                    generatePath(`${settingsPath}/subscriptions`, { projectId }),
                Management: {
                    Path: `${settingsPath}/subscriptions/commentsPanel`,
                    Builder: (projectId: string): string =>
                        generatePath(`${settingsPath}/subscriptions/commentsPanel`, { projectId }),
                },
                Views: {
                    Path: `${settingsPath}/subscriptions/alarms`,
                    Builder: (projectId: string): string =>
                        generatePath(`${settingsPath}/subscriptions/alarms`, { projectId }),
                },
            },
            Users: {
                Path: `${settingsPath}/users`,
                Builder: (projectId: string): string =>
                    generatePath(`${settingsPath}/users`, { projectId }),
                Management: {
                    Path: `${settingsPath}/users/management`,
                    Builder: (projectId: string): string =>
                        generatePath(`${settingsPath}/users/management`, { projectId }),
                },
                roles: {
                    Path: `${settingsPath}/users/roles`,
                    Builder: (projectId: string): string =>
                        generatePath(`${settingsPath}/users/roles`, { projectId }),
                },
            },
            Planning: {
                Path: `${settingsPath}/planning`,
                Builder: (projectId: string): string =>
                    generatePath(`${settingsPath}/planning`, { projectId }),
                Management: {
                    Path: `${settingsPath}/planning/management`,
                    Builder: (projectId: string): string =>
                        generatePath(`${settingsPath}/planning/management`, { projectId }),
                },
                States: {
                    Path: `${settingsPath}/planning/states`,
                    Builder: (projectId: string): string =>
                        generatePath(`${settingsPath}/planning/states`, { projectId }),
                },
            },
            SmallVolumes: {
                Path: `${settingsPath}/smallvolumes`,
                Builder: (projectId: string): string =>
                    generatePath(`${settingsPath}/smallvolumes`, { projectId }),
                Management: {
                    Path: `${settingsPath}/smallvolumes/management`,
                    Builder: (projectId: string): string =>
                        generatePath(`${settingsPath}/smallvolumes/management`, { projectId }),
                },
            },
            Interference: {
                Path: `${settingsPath}/interferencesettings`,
                    Builder: (projectId: string): string =>
                        generatePath(`${settingsPath}/interferencesettings`, { projectId }),
            },
        },
        Signals: {
            Path: signalsPath,
            Builder: (projectId: string): string => generatePath(`${signalsPath}`, { projectId }),
        },
    },
};

export interface IPlatformType {
    id: number;
    key: string;
}

type IConnectorTypes = {
    [key in DocumentManagerType]: IPlatformType;
};

export const CONNECTOR_TYPES: IConnectorTypes = {
    [DocumentManagerType.NextCloud]: {
        id: DocumentManagerType.NextCloud,
        key: "NextCloud",
    },
    [DocumentManagerType.AzureBlobStorage]: {
        id: DocumentManagerType.AzureBlobStorage,
        key: "AzureBlobStorage",
    },
};

export const ModelViewerModes = {
    Viewer: "viewer",
    Assets: "assets",
    Documentation: "documentation",
    WorkOrders: "workorders",
};

export enum GeometriesEnum {
    Sphere = 1,
    Cuboid = 2,
    Cylinder = 3,
    NotGeometry = 4,
}

export interface IPowerBIReportElementData {
    id: string;
    assetName: string;
    data: { [key: string]: string };
}

export /* declare */ enum ModelViewerPanelAnchor {
    Top,
    Bottom,
    Left,
    Right,
}

export enum ErrorType {
    SUCCESS = "success",
}
